module.exports = __webpack_public_path__ + "static/media/fc-bg.81e17316.webp";